module.exports = __webpack_public_path__ + "img/ISR.de473c66.svg";